import axiosInstance from "@/utils/axios";
import { handleAxiosError } from "@/utils/helpers/handle-axios-errors";

export const getStakingInfo = async (): Promise<any> => {
  try {
    return await axiosInstance.get<StakingInfo>("/api/nft/stakingInfo");
  } catch (error) {
    handleAxiosError(error);
  }
};

export const stakeNow = async (tokenId: number | string) => {
  try {
    return await axiosInstance.post<any>(`/api/nft/${tokenId}/stakeNow`);
  } catch (error) {
    handleAxiosError(error);
  }
};

export const completeTransaction = async (data: any) => {
  try {
    return await axiosInstance.post<any>("/api/game/done", data);
  } catch (error) {
    handleAxiosError(error);
  }
};

export const getProfileData = async () => {
  try {
    return await axiosInstance.get<any>("/api/user/profile");
  } catch (error) {
    handleAxiosError(error);
  }
};

export const updateProfileData = async (formData: any) => {
  try {
    return await axiosInstance.post<any>("/api/user/profile", formData);
  } catch (error) {
    handleAxiosError(error);
  }
};

export const getCalculator = async () => {
  try {
    return await axiosInstance.get<CalculatorData>("/api/misc/calculate");
  } catch (error) {
    handleAxiosError(error);
  }
};

export const getNftData = async () => {
  try {
    return await axiosInstance.get("/api/nft/all-balance");
  } catch (error) {
    handleAxiosError(error);
  }
};
